var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgHeartActive = function SvgHeartActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.205,
    height: 16.622
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.1 16.622a.522.522 0 01-.377-.162L1.385 8.6A5.189 5.189 0 010 5.041a5.179 5.179 0 011.385-3.554 4.565 4.565 0 016.742 0L9.1 2.535l.975-1.04a4.574 4.574 0 016.743 0 5.185 5.185 0 011.387 3.555A5.182 5.182 0 0116.82 8.6l-3.558 3.81-.114.122-3.672 3.928a.526.526 0 01-.376.162zM4.756 1.016z",
    fill: "#ea6c68"
  })));
};

export default SvgHeartActive;